module.exports = __webpack_public_path__ + "media/images/loghi/mail_header-57e87ea09f0dff89cddaf44d7542fa8b.png";